// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.5_@rspack+core@2.2.3_@module-federation+runtime-tools@2.9.0__webpack@5.110.3/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.5_@rspack+core@2.2.3_@module-federation+runtime-tools@2.9.0__webpack@5.110.3/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#app-root {
  height: 100%;
}
body {
  height: 100vh;
  overflow-x: hidden;
}
.roster-root {
  height: 100%;
}
.ant-layout.page-layout {
  position: relative;
  overflow: auto;
}
.ant-layout-content.page-content {
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
}
.ant-layout-content.page-content .ant-table-wrapper {
  margin: 0 24px 24px 24px;
}
.ant-layout-content.page-content.file-list-page .file-loader-file-table .ant-table-wrapper {
  margin: 0;
}
.ant-layout-header.page-header {
  background: transparent;
  padding: 0 24px;
  display: flex;
  align-items: center;
  height: 80px;
}
.ant-layout-header.page-header > .ant-row {
  width: 100%;
}
.ant-layout-content.app-content {
  flex-shrink: 0;
}
.ant-breadcrumb-link > a > .anticon,
.ant-breadcrumb-link > .anticon {
  margin-right: 4px;
}
.activity-indicator {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.section {
  background: #fafafa;
  width: calc(100% - 48px);
  margin: 0 24px 24px 24px;
  padding: 24px;
  border: 1px solid #e6e6e6;
  border-radius: 4px;
}
.alert-section {
  width: calc(100% - 48px);
  margin: 0 24px 24px 24px;
}
@media (min-width: 0px) {
  .section.left {
    margin: 0 24px 24px 24px;
    width: calc(100% - 48px);
  }
  .section.right {
    margin: 0 24px 24px 24px;
    width: calc(100% - 48px);
  }
  .section.middle {
    margin: 0 24px 24px 24px;
    width: calc(100% - 48px);
  }
}
@media (min-width: 992px) {
  .section.left {
    margin-right: 12px;
    width: calc(100% - 36px);
  }
  .section.right {
    margin-left: 12px;
    width: calc(100% - 36px);
  }
  .section.middle {
    margin-left: 12px;
    width: calc(100% - 24px);
  }
}
.section > form {
  margin-bottom: -24px;
}
.section-header {
  display: flex;
  align-items: center;
  font-size: 18px;
  height: 32px;
  line-height: 32px;
  margin-bottom: 24px;
  margin-top: 0;
  font-weight: 400;
}
.roster-group-load-buttons {
  margin-left: auto;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
